/* eslint-disable no-empty */

import './index.css';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { isMobileBrowser } from '../../utilities/helper';
import { useEffect, useState } from 'react';
import useTheme from '../../utilities/hooks/theme';
import { useDispatch, useSelector } from 'react-redux';
import {
  getPromoCodeList,
  verifyPromoCode,
  updatePaytmSdkResponse,
  updateCashfreeSdkResponse
} from '../../actions/account-actions-types';
import I18n from '../../utilities/locale';
import View from '../view';
import Text from '../text';
import Constants from '../../constants';
import { MdDelete } from 'react-icons/md';
import Button from '@mui/material/Button/Button';
import 'react-activity/dist/Spinner.css';
import { Spinner } from 'react-activity';
import TextField from '@mui/material/TextField/TextField';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import React from 'react';
import Regex from '../../utilities/Regex';
import EventEmitter from '../../utilities/EventEmitter';

interface Props {
  totalAmount: number;
  visible: boolean;
  onPressDismiss?: any;
  isPokerWebView?: boolean;
}

const AddCashModal = ({
  totalAmount,
  visible,
  onPressDismiss
}: // isPokerWebView,
Props) => {
  const bottomSheetWidth = isMobileBrowser ? 'root_mobile' : 'root';
  const className = `${bottomSheetWidth}`;
  const { AccountTheme: theme } = useTheme();
  const [loading] = useState(false);
  const [loadingPromoCode, setLoadingPromoCode] = useState(false);
  const [amountError, setAmountError] = useState(null);
  const [amount, setAmount] = useState('' as any);
  const [promoCode, updatePromoCode] = useState('');
  const [promoList, setPromoList] = useState([]);
  const [promoCodeError, updatePromoCodeError] = useState(null);
  const [promoCodeSuccess, updatePromoCodeSuccess] = useState(false);
  const dispatch = useDispatch();
  const { referAffiliateId = '' } = useSelector((state: any) => state.user);

  useEffect(() => {
    if (visible && promoList.length === 0) getCouponList();
    window.addEventListener('message', eventListener);
    return () => {
      window.removeEventListener('message', eventListener);
    };
  }, [visible]);

  const eventListener = (event: any) => {
    if (event?.data?.command_type) {
      if (event.data.command_type === 'paytm_transaction_update') {
        try {
          const { STATUS = '' } = event?.data?.value || {};
          if (STATUS === 'TXN_SUCCESS') {
            if (referAffiliateId && referAffiliateId.length > 0) {
              amount;
            }
          }
        } catch (error) {}
        transactionPaytmUpdate(event.data.value);
      } else if (event.data.command_type === 'cashfree_transaction_update') {
        try {
          const { txStatus = '' } = JSON.parse(event?.data?.value || {});
          if (txStatus === 'SUCCESS') {
            console.log('success');
          }
        } catch (error) {}
        transactionCashfreeUpdate(event.data.value);
      }
    }
  };

  const transactionPaytmUpdate = (data: any) => {
    dispatch(
      updatePaytmSdkResponse({
        data,
        callback: ({ result }: { result: any }) => {
          if (result) {
            EventEmitter.emit('BalanceUpdate');
          }
        }
      })
    );
  };

  const transactionCashfreeUpdate = (data: any) => {
    dispatch(
      updateCashfreeSdkResponse({
        data,
        callback: ({ result }: { result: any }) => {
          if (result) {
            EventEmitter.emit('BalanceUpdate');
          }
        }
      })
    );
  };

  /* eslint-disable-next-line no-unused-vars */

  const getCouponList = () => {
    dispatch(
      getPromoCodeList({
        data: {},
        callback: ({ result = [] }) => {
          if (result) {
            result.filter(
              (item: { usageCountPerUser: number; usageLeft: number }) =>
                item.usageCountPerUser > 0 && item.usageLeft > 0
            );
            setPromoList(result);
          }
        }
      })
    );
  };

  const verifyAmountAndPhone = () => {
    if (amount === '') {
      setAmountError(I18n.t('PleaseEnterAmount'));
      return false;
    }
    if (amount < 50) {
      setAmountError(I18n.t('EnterMinimumAmount'));
      return false;
    }
    return true;
  };

  // eslint-disable-next-line no-unused-vars
  const onPressPaytm = () => {
    let isAmountPhoneAdded = verifyAmountAndPhone();
    if (!isAmountPhoneAdded) return;
    const data = {
      orderAmount: parseInt(amount)
    } as any;
    if (promoCodeSuccess) {
      data.promoCode = promoCode.toUpperCase();
    }
    onPressDismiss();
  };

  const onPressCashfree = () => {
    let isAmountPhoneAdded = verifyAmountAndPhone();
    if (!isAmountPhoneAdded) return;
    const data = {
      orderAmount: parseInt(amount)
    } as any;
    if (promoCodeSuccess) {
      data.promoCode = promoCode.toUpperCase();
    }
    onPressDismiss();
    // if (window) {
    // } else proceedToCashfreeViaWeb(data);
  };

  const onPressVerifyPromo = () => {
    if (amount > 0) {
      if (promoCode !== '') {
        setLoadingPromoCode(true);
        const data = {
          promoCode: promoCode.toUpperCase(),
          amount: amount * 100
        };
        dispatch(
          verifyPromoCode({
            data,
            callback: ({ result, error }: { result: any; error: any }) => {
              setLoadingPromoCode(false);
              if (!error && result) {
                updatePromoCodeSuccess(true);
              } else if (error.message) {
                updatePromoCodeError(error.message);
              } else {
                updatePromoCodeError(I18n.t('SomethingWentWrong'));
              }
            }
          })
        );
      } else {
        updatePromoCodeError(I18n.t('PleaseEnterPromoCode'));
      }
    } else {
      updatePromoCodeError(I18n.t('PleaseEnterAmount'));
    }
  };

  const onPressRemoveImage = () => {
    updatePromoCode('');
    updatePromoCodeSuccess(false);
    promoList.map((item: { isSelect: boolean }) => {
      item.isSelect = false;
      return item;
    });
  };

  const onChangePromoCode = (event: any) => {
    updatePromoCode(event.target.value);
    if (promoCodeError !== null) updatePromoCodeError(null);
  };

  const onSetAmount = (event: any) => {
    if (Regex.validateNumber(event.target.value) || event.target.value === '') {
      setAmount(event.target.value);
      if (amountError !== null) setAmountError(null);
      if (promoCodeError !== null) updatePromoCodeError(null);
    }
  };

  const _onSetAmount = (amt: any) => {
    setAmount(amt);
    if (amountError !== null) setAmountError(null);
    if (promoCodeError !== null) updatePromoCodeError(null);
  };

  const promoCodeItemTitle = {
    color: theme.addCashPromoListItemTitle
  };

  const onRenderPromoItem = (
    item: {
      isSelect?: any;
      code?: any;
      _id?: any;
      minDepositPerTransaction?: any;
      bonusCap?: any;
      percentage?: any;
      type?: any;
    },
    index: any
  ) => {
    const {
      _id,
      minDepositPerTransaction = 0,
      bonusCap = 0,
      percentage = 0,
      type = 'deposit'
    } = item;
    return (
      <View
        key={_id}
        className={'add-cash-modal-promo-code-item-container'}
        style={{
          borderWidth: item.isSelect ? '1px' : 0,
          borderColor: theme.addCashPromoListItemBorder,
          backgroundColor: theme.addCashPromoListItemBG
        }}
        onPress={() => onPressPromoCode(item.code, index)}>
        <Text
          className={'add-cash-modal-promo-code-item-title'}
          style={promoCodeItemTitle}>{`${item.code}`}</Text>
        <Text className={'add-cash-modal-promo-code-item-bonus'} style={promoCodeItemTitle}>
          {`Valid on Min. Deposit ₹${minDepositPerTransaction / 100}/-`}
        </Text>
        <Text className={'add-cash-modal-promo-code-item-bonus'} style={promoCodeItemTitle}>
          {`Get ${percentage}% ${type === 'cashback' ? 'Cashback' : 'Bonus'} up to ₹${
            bonusCap / 100
          }/-`}
        </Text>
      </View>
    );
  };

  const onPressPromoCode = (code: any, selectIndex: number) => {
    promoList.map((item: { isSelect: boolean }, index) => {
      if (index === selectIndex) {
        item.isSelect = true;
      } else item.isSelect = false;
      return item;
    });
    updatePromoCode(code);
    if (promoCodeError != null) {
      updatePromoCodeError(null);
    }
  };

  const inputSx: SxProps<Theme> = {
    '& .MuiInputBase-input': {
      color: theme.simpleTextInput,
      fontSize: '1.1rem',
      fontFamily: 'ProximaNova-Regular',
      textTransform: 'uppercase'
    },
    '& .MuiFormHelperText-root.Mui-error': {
      backgroundColor: theme.addCashContainer,
      margin: 0,
      color: theme.simpleTextInputError,
      paddingLeft: '5px',
      fontSize: '1.1rem',
      fontFamily: 'ProximaNova-Regular',
      textTransform: 'none'
    },
    '& .MuiInputLabel-root': {
      color: theme.simpleTextInput,
      fontSize: '1.1rem',
      fontFamily: 'ProximaNova-Regular',
      textTransform: 'none'
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.simpleTextInput,
      fontSize: '1.1rem',
      fontFamily: 'ProximaNova-Regular',
      textTransform: 'none'
    },
    '& input::placeholder': {
      color: theme.simpleTextInputPlaceholder,
      fontSize: '1.1rem',
      textTransform: 'none'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.simpleTextInput
      },
      '&:hover fieldset': {
        borderColor: theme.simpleTextInput
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.simpleTextInput,
        borderWidth: '1px'
      }
    }
  };

  const containerColor = {
    backgroundColor: theme.addCashContainer
  };

  const addCashTitleColor = {
    color: theme.addCashTitle
  };

  const currentBalanceColor = {
    color: theme.addCashCurrentBalance
  };

  const currentBalanceValueColor = {
    color: theme.addCashCurrentBalanceValue
  };

  const AmountWrapperColor = {
    backgroundColor: theme.addCashBoxAmountWrapper,
    borderColor: theme.addCashBoxAmountWrapperBorder,
    color: theme.addCashBoxAmountText
  };

  const subLabelColor = {
    color: theme.addCashPromoCodeLabel
  };

  const promoTextColor = {
    color: theme.addCashAppliedPromoCode
  };

  const verifyButtonColor = {
    backgroundColor: theme.addCashApplyButton,
    color: theme.addCashApplyButtonText
  };

  // const verifyButtonSuccessColor = {
  //   borderColor: theme.success
  // };

  // const greenTextColor = {
  //   color: theme.success
  // };

  const promoCodeInputColor = {
    backgroundColor: theme.simpleTextInputBG,
    color: theme.simpleTextInput
  };

  const verticalDivider = {
    backgroundColor: theme.addCashVerticalDivider
  };

  const submitBtn = {
    backgroundColor: theme.addCashBtn,
    color: theme.addCashBtnText
  };

  const minimumWithdrawLabelColor = {
    color: theme.withdrawMinAmountLabel
  };

  return (
    <BottomSheet className={className} onDismiss={onPressDismiss} open={visible}>
      <View className={'add-cash-modal-container'} style={containerColor}>
        <View className={'add-cash-modal-header'}>
          <View style={{ position: 'absolute', left: 15 }} onPress={onPressDismiss}>
            <Constants.Svgs.ModalBack width={20} height={20} fill={theme.addCashBackBtn} />
          </View>
          <Text className={'add-cash-modal-title'} style={addCashTitleColor}>
            {I18n.t('AddCash')}
          </Text>
        </View>
        <View className={'add-cash-modal-divider'} style={verticalDivider} />
        <View className={'add-cash-modal-header-balance'}>
          <Text className={'add-cash-modal-balance'} style={currentBalanceColor}>
            {I18n.t('CurrentBalance')}
          </Text>
          <Text className={'add-cash-modal-balance-value'} style={currentBalanceValueColor}>
            {`  : ₹${totalAmount}`}
          </Text>
        </View>
        <View className={'add-cash-modal-content-wrapper'}>
          <TextField
            style={promoCodeInputColor}
            placeholder={I18n.t('EnterDepositAmount')}
            value={amount}
            className={'add-cash-modal-text-input'}
            label={I18n.t('EnterDepositAmount')}
            variant="outlined"
            size={'small'}
            onChange={onSetAmount}
            sx={inputSx}
            error={amountError ? true : false}
            helperText={amountError}
            autoCapitalize={'none'}
            type="tel"
          />
          <Text className={'add-cash-modal-min-deposit-label'} style={minimumWithdrawLabelColor}>
            {I18n.t('MinimumDepositAmount')}
          </Text>
          <View className={'add-cash-modal-amt-box-container'}>
            <Button
              className={'add-cash-modal-amt-box'}
              style={AmountWrapperColor}
              onClick={() => {
                _onSetAmount('250');
              }}>
              {'₹250'}
            </Button>
            <Button
              className={'add-cash-modal-amt-box'}
              style={AmountWrapperColor}
              onClick={() => {
                _onSetAmount('500');
              }}>
              {'₹500'}
            </Button>
            <Button
              className={'add-cash-modal-amt-box'}
              style={AmountWrapperColor}
              onClick={() => {
                _onSetAmount('1000');
              }}>
              {'₹1000'}
            </Button>
            <Button
              className={'add-cash-modal-amt-box'}
              style={AmountWrapperColor}
              onClick={() => {
                _onSetAmount('2000');
              }}>
              {'₹2000'}
            </Button>
          </View>

          <Text className={'add-cash-modal-sub-label'} style={subLabelColor}>
            {I18n.t('HavePromoCode')}
          </Text>
          {promoCodeSuccess ? (
            <View className={'add-cash-modal-button-wrapper'}>
              <View className={'add-cash-modal-promo-wrapper'}>
                <Text className={'add-cash-modal-promo-text'} style={promoTextColor}>
                  {promoCode}
                </Text>
                <View onPress={onPressRemoveImage}>
                  <MdDelete size={25} color={theme.addCashRemoveIcon} />
                </View>
              </View>
              <Button>{I18n.t('Applied')}</Button>
            </View>
          ) : (
            <View className={'add-cash-modal-button-wrapper'}>
              <TextField
                style={promoCodeInputColor}
                placeholder={I18n.t('PromoCode')}
                value={promoCode}
                className={'add-cash-modal-promo-code-ip'}
                label={I18n.t('PromoCode')}
                variant="outlined"
                size={'small'}
                onChange={onChangePromoCode}
                sx={inputSx}
                error={promoCodeError ? true : false}
                helperText={promoCodeError}
                autoCapitalize="characters"
              />
              <View>
                {loadingPromoCode ? (
                  <Spinner
                    style={{
                      marginLeft: '10px'
                    }}
                    color={theme.addCashPromoLoader}
                    size={12}
                    speed={1}
                    animating={true}
                  />
                ) : (
                  <Button
                    className={'add-cash-modal-apply-btn'}
                    style={verifyButtonColor}
                    onClick={onPressVerifyPromo}>
                    {I18n.t('Apply')}
                  </Button>
                )}
              </View>
            </View>
          )}
          {promoList.length > 0 && (
            <>
              <Text className={'add-cash-modal-sub-label'} style={subLabelColor}>
                {'Promo Code List'}
              </Text>
              <View
                style={{
                  flexWrap: 'nowrap',
                  overflowX: 'auto',
                  flexDirection: 'row'
                }}>
                {promoList.map(onRenderPromoItem)}
              </View>
            </>
          )}

          <View className={'add-cash-modal-pay-wrapper'}>
            {/* <Text className={'add-cash-modal-sub-label'} style={{ color: theme.addCashPayUsing }}>
              {I18n.t('PayUsing')}
            </Text> */}
            <View className={'add-cash-modal-button-wrapper'}>
              {!loading ? (
                <>
                  {/* <Button
                    style={submitBtn}
                    onClick={onPressPaytm}
                    className={'add-cash-modal-other-methods'}>
                    {'Paytm'}
                  </Button> */}
                  <Button
                    style={submitBtn}
                    onClick={onPressCashfree}
                    className={'add-cash-modal-other-methods'}>
                    {'Pay'}
                  </Button>
                </>
              ) : (
                <Spinner color={theme.addCashPromoLoader} size={20} speed={1} animating={true} />
              )}
            </View>
          </View>
        </View>
      </View>
    </BottomSheet>
  );
};

export default React.memo(AddCashModal);
